const StoreHours = `
    hours.delivery,         delivery_hours;
    hours.open,             business_hours;
`

export default StoreHours;